/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#2c2e30',
    height: 64,
    iconColor: '#ffffff',
    width: 64
  }
}
export default theme
